import * as React from "react";
import LeadStatus from "../../../../model/lead/LeadStatus";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import LeadStatusForm from "../LeadStatusForm";
import LeadStatusFormBody from "../LeadStatusFormBody";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {LeadStatus} data edited lead status data.
	 */
	onSubmit: (data: LeadStatus) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Lead status to edit
	 */
	editedLeadStatus: LeadStatus;
}

type IState = BaseFormViewState<LeadStatusForm>;

export default class EditLeadStatusFormView extends BaseFormView<LeadStatusForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: LeadStatusForm.createFromLeadStatus(this.props.editedLeadStatus),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<LeadStatusFormBody form={this.state.form}
									onFieldChange={this.onFieldChanged}
									onFieldCompleted={this.onFieldCompleted}
									onFocusChange={this.onFocusChange}
									onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update Status"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}
